import { gql, useMutation } from "@apollo/client";
import { Modal, AllocateMeterDeliveryMaterialsForm } from "components";
import { useFormik } from "formik";
import { FC } from "react";
import toast from "react-hot-toast";
import { wrapClick } from "utils";
import {
  AllocateMeterDeliveryMaterialsInitialValues,
  AllocateMeterDeliveryMaterialsSchema,
} from "components/forms";
import { useMatch } from "react-location";
import { LocationGenerics } from "router/location";

const ALLOCATE_METER_DELIVERY_MATERIALS = gql`
  mutation AllocateMeterDeliveryRequestMaterials(
    $deliveryRequest: ID!
    $allocations: [MeterDeliveryRequestMaterialsAllocationInput!]!
    $notes: String
  ) {
    allocateMeterDeliveryRequestMaterials(
      deliveryRequest: $deliveryRequest
      allocations: $allocations
      notes: $notes
    ) {
      _id
    }
  }
`;

interface AllocateMeterDeliveryMaterialsContainerProps {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
  materials?: any
}

const AllocateMeterDeliveryMaterialsContainer: FC<AllocateMeterDeliveryMaterialsContainerProps> = ({
  open,
  setOpen,
  refetch,
  materials,
}) => {
  const [allocateMeterDeliveryMaterials, { loading }] = useMutation(
    ALLOCATE_METER_DELIVERY_MATERIALS
  );


  const { params } = useMatch<LocationGenerics>();

  const form = useFormik<any>({
    initialValues: AllocateMeterDeliveryMaterialsInitialValues,
    validationSchema: AllocateMeterDeliveryMaterialsSchema,
    onSubmit: async (values) => {
      await allocateMeterDeliveryMaterials({
        variables: {
          ...values,
          allocations: values?.allocations?.map((allocation: any) => ({
            district: allocation.district?._id,
            districtCode: allocation?.district?.code,
            districtName: allocation?.district?.name,
            materials: allocation.materials,
          })),
          deliveryRequest: params.deliveryRequest,
        },
      }).then(({ data }) => {
        if (data.allocateMeterDeliveryRequestMaterials._id) {
          toast(
            JSON.stringify({
              type: "success",
              title: "Complementary materials allocated successfully",
            })
          );
          refetch?.();
          form.resetForm();
        } else {
          toast(
            JSON.stringify({ type: "error", title: "Could not allocate complementary materials" })
          );
        }
      });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title='Allocate Complementary Materials'
      description='Provide the details to allocate the materials by district'
      renderActions={() => (
        <>
          <button
            type='button'
            disabled={loading}
            className='w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm'
            onClick={wrapClick(form.handleSubmit)}
          >
            {loading ? "Allocating Materials..." : "Allocate Materials"}
          </button>
        </>
      )}
    >
      <AllocateMeterDeliveryMaterialsForm form={form} materials={materials?.materials} />
    </Modal>
  );
};

export default AllocateMeterDeliveryMaterialsContainer;
